/**
 * Featured Packed — lazy loader
 *
 * Card images are rendered with `data-srcset` / `data-src` (see
 * snippets/responsive-picture.liquid with `lazy_load: true`) so NOTHING is
 * requested on page load. This script swaps them to real sources once a slider
 * nears the viewport.
 *
 * Handles this section's specifics:
 *   - Multiple instances with dynamic IDs (`#featured-packed-splide-<id>`).
 *   - Splide `type: 'loop'`, which CLONES slides — we query the live DOM at swap
 *     time so clones are covered (the re-run also catches clones made at mount).
 *   - Variant changes that replace the slide HTML and re-mount Splide:
 *     featured-packed.js calls `window.FeaturedPackedLazy.observe(slider)` on the
 *     fresh markup so the new images lazy-load the same way.
 *
 * Exposes `window.FeaturedPackedLazy = { observe, loadAll }`.
 */
(function () {
  'use strict';

  function swapPicture(picture) {
    var sources = picture.querySelectorAll('source[data-srcset]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].srcset = sources[i].getAttribute('data-srcset');
      sources[i].removeAttribute('data-srcset');
    }

    var img = picture.querySelector('img[data-src]');
    if (img) {
      if (img.getAttribute('data-srcset')) {
        img.srcset = img.getAttribute('data-srcset');
        img.removeAttribute('data-srcset');
      }
      img.addEventListener('load', function () {
        img.classList.add('pdp-lazy-loaded');
      });
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.classList.remove('pdp-lazy-img');
    }
  }

  function loadAll(scope) {
    if (!scope) return;
    var pictures = scope.querySelectorAll('picture');
    for (var i = 0; i < pictures.length; i++) {
      swapPicture(pictures[i]);
    }
  }

  function observe(slider) {
    if (!slider) return;

    // Fallback: no IntersectionObserver -> just load everything.
    if (!('IntersectionObserver' in window)) {
      loadAll(slider);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;

          // Swap now, then once more shortly after so any slides Splide
          // clones during/after mount are picked up too.
          loadAll(slider);
          window.setTimeout(function () {
            loadAll(slider);
          }, 250);

          observer.disconnect();
          break;
        }
      },
      {
        rootMargin: '300px 0px',
        threshold: 0.01,
      }
    );

    observer.observe(slider);
  }

  // Public API (used by featured-packed.js after variant re-renders).
  window.FeaturedPackedLazy = { observe: observe, loadAll: loadAll };

  function init() {
    var sliders = document.querySelectorAll('[id^="featured-packed-splide-"]');
    for (var i = 0; i < sliders.length; i++) {
      observe(sliders[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
